import { Helmet } from "react-helmet-async";
import { SITE, HOURS } from "../../lib/site";

const origin = () => (typeof window !== "undefined" ? window.location.origin : "");

export const businessSchema = () => ({
  "@context": "https://schema.org",
  "@type": "AutoRepair",
  "@id": `${origin()}/#business`,
  name: SITE.name,
  brand: { "@type": "Brand", name: "A+ Glass" },
  url: `${origin()}/`,
  telephone: SITE.phoneSchema,
  email: SITE.email,
  image: `${origin()}/images/facade-haguenau.webp`,
  address: { "@type": "PostalAddress", streetAddress: SITE.street, postalCode: SITE.zip, addressLocality: SITE.city, addressCountry: "FR" },
  areaServed: { "@type": "City", name: "Haguenau" },
  openingHoursSpecification: HOURS.filter((h) => h.open).map((h) => ({
    "@type": "OpeningHoursSpecification",
    dayOfWeek: `https://schema.org/${["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"][h.d]}`,
    opens: h.open,
    closes: h.close,
  })),
});

export const faqSchema = (items) => ({
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: items.map((f) => ({ "@type": "Question", name: f.q, acceptedAnswer: { "@type": "Answer", text: f.a } })),
});

export const serviceSchema = (s) => ({
  "@context": "https://schema.org",
  "@type": "Service",
  name: s.h1,
  serviceType: s.nav,
  description: s.description,
  provider: { "@id": `${origin()}/#business` },
  areaServed: { "@type": "City", name: "Haguenau" },
  url: `${origin()}${s.path}`,
});

export const breadcrumbSchema = (items) => ({
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  itemListElement: items.map((it, i) => ({ "@type": "ListItem", position: i + 1, name: it.label, item: `${origin()}${it.to}` })),
});

export function Seo({ title, description, path = "/", image = "/images/facade-haguenau.webp", schemas = [], noindex = false, type = "website" }) {
  const url = `${origin()}${path}`;
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
      {noindex && <meta name="robots" content="noindex, nofollow" />}
      <meta property="og:type" content={type} />
      <meta property="og:locale" content="fr_FR" />
      <meta property="og:site_name" content={SITE.name} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={`${origin()}${image}`} />
      <meta name="twitter:card" content="summary_large_image" />
      {[businessSchema(), ...schemas].map((s, i) => (
        <script key={i} type="application/ld+json">{JSON.stringify(s)}</script>
      ))}
    </Helmet>
  );
}
